import { render, staticRenderFns } from "./CompleteInformation.vue?vue&type=template&id=508384c0"
import script from "./CompleteInformation.vue?vue&type=script&lang=js"
export * from "./CompleteInformation.vue?vue&type=script&lang=js"
import style0 from "./CompleteInformation.vue?vue&type=style&index=0&id=508384c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports